<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $tc("add") }} {{ $t("floatAmount") }}</div>
      <router-link class="btn-blue" to="float-amount">{{ $t("floatAmount") }} {{ $tc("list", 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <div class="mb-4 font-weight-bold">
        {{ $tc("cinema", 1) }} {{ $t("name") }}
      </div>
      <form class="row">
        <div class="col-lg-3 col-xl-2 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.user.length > 0 ? 'shift-up' : ''">{{
                $tc("user", 1)
              }}</label>
              <b-dropdown :text="selected.user" variant="dropdown-curve" class="w-100" v-b-tooltip.hover
                :title="$t('floatAmount_User')">
                <div class="px-2 pb-2">
                  <input required autofocus type="search" placeholder="Search User" class="form-control form-control-sm"
                    v-on:keyup="onSearchUser()" v-on:keydown="onSearchUser()" v-on:search="onSearchUser()"
                    v-model="searchUser" />
                </div>
                <b-dropdown-item v-for="(User, UserIndex) in Users" :key="UserIndex"
                  v-on:click="onSelectUser($event, User)">{{ User.first_name }} {{ User.last_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <!--Tooltip :title="$t('floatAmount_User')" /--->
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.user.length == 0">Please Select User.</span>
          </p>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.shift.length > 0 ? 'shift-up' : ''">{{
                $tc("shift", 1)
              }}</label>
              <b-dropdown :text="selected.shift" variant="dropdown-curve" class="w-100" v-b-tooltip.hover
                :title="$t('floatAmount_Shift')">
                <b-dropdown-item v-for="(UserShift, UserShiftIndex) in userShifts" :key="UserShiftIndex"
                  v-on:click="onSelectUserShift($event, UserShift)">{{ UserShift.shift_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <!--Tooltip :title="$t('floatAmount_Shift')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.shift.length == 0">Please Select Shift.</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selected.posOperation.length > 0 ? 'shift-up' : ''">{{ $t("selectmachine") }}</label>
              <b-dropdown :text="selected.posOperation" variant="dropdown-curve" class="w-100" v-b-tooltip.hover
                :title="$t('floatAmount_PosOperation')">
                <b-dropdown-item v-for="(PosOperation, PosOperationIndex) in posOperations" :key="PosOperationIndex"
                  v-on:click="onSelectPosOperation($event, PosOperation)">{{ PosOperation.hs_hardware_name
                  }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <!--Tooltip :title="$t('floatAmount_PosOperation')" /--->
          </div>
          <p class="error_message">
            <!-- <span v-if="submitted && selected.posOperation.length == 0"
              >Please Select Machine.</span
            > -->
          </p>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input placeholder="." step="any" v-model="floatAmountObject.float_amount_given" type="text"
                name="floatamount" id="floatamount" v-validate="'required|decimal'" v-b-tooltip.hover
                :title="$t('floatAmount_Amount')" />
              <label>{{ $t("floatAmount") }}</label>
            </div>
            <!--Tooltip :title="$t('floatAmount_Amount')" /--->
          </div>
          <p class="error_message">
            <span v-if="
              submitted &&
              floatAmountObject.float_amount_given.length &&
              errors.has('floatamount')
            ">{{ errors.first("floatamount") }}</span>
          </p>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-2">
          <div class="row justify-content-center" style="gap:10px">
            <div class="">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="">
              <div class="">
                <b-form-checkbox unchecked-value="N" v-model="floatAmountObject.float_is_active" value="Y"
                  name="check-button" class="j-checkbox"></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-1">
          <button :disabled="btenable" @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
            {{ $t("save") }}
          </button>
          <button :disabled="btenable" @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="float-amount">{{ $t("cancel") }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import { decryptString } from "@/helper/collection"

export default {
  data() {
    return {
      UsersCopy: [],
      searchUser: "",
      btenable: false,
      submitted: false,
      // Saif
      currencyData: [],

      Currencies: [],
      cinema_id: null,
      posOperations: [],
      userShifts: [],
      Users: [],
      selected: {
        posOperation: "",
        user: "",
        shift: ""
      },
      floatAmountObject: {
        currency_id: null,
        float_id: null,
        float_amount_given: "",
        manager_user_id: null,
        operator_user_id: null,
        hardware_setting_id: null,
        shift_id: null,
        float_is_active: "Y",
        created_at: null,
        created_by: null
      },
      // Saif
      checked: "y",
      selectedNewDate: "",
      selecedCinema: ""
    };
  },
  beforeMount() {
    // Note: // Get cinema_id when user will login // if cinema_id is null he can't access this page.
    const { cinema_id = null } = this.$route.query;
    if (!cinema_id) {
      this.$toasted.show("Cinema is missing")
      return this.$router.push("/cinema-manager/float-amount")
    }
    let user_info = this.secureStore.get("USINFO");
    let decryptedString = decryptString(String(cinema_id))
    this.cinema_id = decryptedString || user_info.cinema_id;
    // Note: // Get manager_user_id when user will login // if manager_user_id is null he can't access this page.
    this.floatAmountObject.manager_user_id = user_info.user_id;
    this.getUsersList();
    this.getPosOperationsList();
    this.getCurrencyCode();

    this.floatAmountObject.currency_id =
      this.secureStore.get("BRGLOPCU") &&
        this.secureStore.get("BRGLOPCU").go_value
        ? this.secureStore.get("BRGLOPCU").go_value
        : null;
  },
  mounted() { },
  methods: {
    onSearchUser: function () {
      if (this.searchUser && this.searchUser.length > 0) {
        this.Users = this.UsersCopy.filter(x => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            x.first_name.toLowerCase().includes(this.searchUser.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Users = this.UsersCopy;
      }
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getShiftsList: function (user_id) {
      this.userShifts = [];

      MasterService.GetUserShiftsByUserId({ user_id, cinema_id: this.cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.userShifts = data.Records;
            }
          } else {
            this.$toasted.show("No shifts found");
          }
        })
        .catch(this._CatchError); //message
    },
    getPosOperationsList: function () {
      this.posOperations = [];
      let payload = {
        tableName: "hardware_settings",
        // cinema_id: this.cinema_id, // // Get cinema_id when user will login // if cinema_id is null he can't access this page.
        hardware_id: 1,
        hs_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.posOperations = data.Records;
          } else {
            //this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getUsersList: function () {
      // let payload = {
      //   tableName: "users",
      //   // cinema_id: this.cinema_id, // Get cinema_id when user will login // if cinema_id is null he can't access this page.
      //   is_active: "Y",
      //   // role_id: 4
      // };
      MasterService.GetUsers({ cine_id: this.cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Users = data.Records;
            this.UsersCopy = data.Records;
            this.Users = this.Users.filter(x => {
              return x.role_id == 4 || x.role_id == 8;
            });
            this.UsersCopy = this.UsersCopy.filter(x => {
              return x.role_id == 4 || x.role_id == 8;
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("Valid :", valid);
        if (valid) {
          this.btenable = true;
          CinemasService.AddFloatAmount({ cinema_id: this.cinema_id, ...this.floatAmountObject })
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/cinema-manager/float-amount"
                  });
                }
                this.submitted = false;
              } else {
                this.submitted = false;
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
    onSelectPosOperation: function (event, params) {
      this.selected.posOperation = params.hs_hardware_name;
      this.floatAmountObject.hardware_setting_id = params.hs_id;
    },
    onSelectUser: function (event, params) {
      this.selected.user = params.first_name + " " + params.last_name;
      this.floatAmountObject.operator_user_id = params.user_id;
      this.getShiftsList(params.user_id);
      this.searchUser = "";
      this.onSearchUser();
    },
    onSelectUserShift: function (event, params) {
      this.selected.shift = params.shift_name;
      this.floatAmountObject.shift_id = params.shift_id;
    },
    onResetForm: function () {
      this.selected = {
        posOperation: "",
        user: "",
        shift: ""
      };

      this.floatAmountObject = {
        float_id: null,
        float_amount_given: "",
        manager_user_id: null,
        operator_user_id: null,
        hardware_setting_id: null,
        shift_id: null,
        float_is_active: "Y",
        created_at: null,
        created_by: null
      };
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FloatAmountComponents/addFloatAmount.vue